import page from 'page'
import ProductionPulse from './demo-wp-cards/production-pulse.js'
// import PPwebApp from './web-app/pp-web-app.ts'
// import PPwebApp from './web-app-test/pp-web-app.js'
import PpWebApp from './pp-web-app/pp-web-app.js'
import PpAZBudget from './pp-az-budget/index.js'
import { enableUx } from '@local_modules/generic/web-paint/components/index.js'

export default function setRoutersProductionPulse (baseRoute) {
  // adminEntityRoutes(baseRoute + '/entity')

  enableUx()

  page(`${baseRoute}`, function (context) {
    console.log('setRoutersProductionPulse')
    console.group('/production-pulse')
    console.log('/production-pulse')
    console.log('context', context)

    // Mount the app
    // customElements.define('pp-anything', PPwebApp)
    // const webApp = new PPwebApp()
    // document.body.innerHTML = ''
    // document.body.appendChild(webApp)

    const ppWebApp = new PpWebApp()
    ppWebApp.mount(document.body)

    console.groupEnd()
  })

  page(`${baseRoute}/az`, function (context) {
    console.log('/az')
    console.group('/production-pulse/az')
    console.log('context', context)

    const ppAZBudget = new PpAZBudget()
    ppAZBudget.mount(document.body)

    console.groupEnd()
  })

  page(`${baseRoute}/*`, function (context) {
    console.group(`${baseRoute}/*`)
    console.log(`${baseRoute}/*`)
    console.log('context', context)
    ProductionPulse()
    console.groupEnd()
  })
}
